import React from 'react';
import { Row, Col } from 'antd';
import cx from 'classnames';

import TotalNumbers from 'features/admin/home/HomePage/HomeDashboard/TotalNumbers';
import PendingCustomerRequests from './HomeDashboard/PendingCustomerRequests';
import PendingAssignmentRequests from './HomeDashboard/PendingAssignmentRequests';
import HomepageAnalytics from './HomeDashboard/HomepageAnalytics';
import SupersetAnalyticsBlock from './HomeDashboard/SupersetAnalyticsBlock';
import { SUPERSET_DASHBOARD_ENABLED } from './HomeDashboard/SupersetAnalyticsBlock/constants';
import styles from './HomePage.module.less';

export default function HomePage() {
  return (
    <div className="page-wrapper scroll-box">
      <div className={cx('page-box', 'page-holder', 'page-inner', styles.dashboardPage)}>
        <div className={cx('page-inner-container', styles.dashboardLayout)}>
          <div className={styles.title}>Admin Dashboard</div>
          <Row gutter={[10, 10]}>
            <Col xs={24} md={12} className="d-flex">
              <TotalNumbers />
            </Col>
            <Col xs={24} md={12} className="d-flex">
              <PendingCustomerRequests />
            </Col>
            <Col xs={24} md={12} className="d-flex">
              <PendingAssignmentRequests />
            </Col>
            <Col xs={24} md={12} className="d-flex">
              <HomepageAnalytics />
            </Col>
          </Row>
          {SUPERSET_DASHBOARD_ENABLED && <SupersetAnalyticsBlock />}
        </div>
      </div>
    </div>
  );
}
